import React from 'react'
import Constant from '../Constant'
import axios from 'axios'
import Swal from 'sweetalert2'

class ShopDashboard extends React.Component {
  state = {
    total_products: 0,
    today_earning: 0,
    total_category: 0,
    total_earning: 0,
    total_store_order_earnings: 0,
    total_delivery_charge: 0,
    today_store_order_earnings: 0,
    total_store_order_delivery_charge: 0,
    total_orders: 0,
    total_store_orders: 0,
  }
  componentDidMount() {
    this.dashbord()
  }

  dashbord = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/user/dashboard', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            total_products: res?.data?.data?.total_products,
            total_category: res?.data?.data?.total_category,
            total_orders: res?.data?.data?.total_orders,
            total_store_orders: res?.data?.data?.total_store_orders,
            today_earning: res?.data?.data?.today_earning,
            total_earning: res?.data?.data?.total_earning,
            total_delivery_charge: res?.data?.data?.total_delivery_charge,
            today_store_order_earnings: res?.data?.data?.today_store_order_earnings,
            total_store_order_delivery_charge: res?.data?.data?.total_store_order_delivery_charge,
            total_store_order_earnings: res?.data?.data?.total_store_order_earnings,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Dashboard</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-yellow f-w-600">{this.state.total_category}</h4>
                          <h6 className="text-muted m-b-0">Total Stores</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-tasks f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-yellow"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-green f-w-600">{this.state.total_products}</h4>
                          <h6 className="text-muted m-b-0">Total Store Products</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-green"></div>
                  </div>
                </div>

                <div className="col-12 m-b-10">
                  <h5 className="text-muted">Orders from Cruise Bookings</h5>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.total_orders}</h4>
                          <h6 className="text-muted m-b-0">Total Orders</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-10">
                          <h4 className="text-c-blue f-w-600">{this.state.total_earning}</h4>
                          <h6 className="text-muted m-b-0">Total Earning </h6>
                        </div>
                        <div className="col-2 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state?.total_delivery_charge}</h4>
                          <h6 className="text-muted m-b-0">Total Delivery Charge </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state?.today_earning}</h4>
                          <h6 className="text-muted m-b-0">Today Earning </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-blue"></div>
                  </div>
                </div>

                <div className="col-12 m-b-10">
                  <h5 className="text-muted">Store Orders</h5>
                </div>

                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state.total_store_orders}</h4>
                          <h6 className="text-muted m-b-0">Total Orders</h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-10">
                          <h4 className="text-c-blue f-w-600">{this.state.total_store_order_earnings}</h4>
                          <h6 className="text-muted m-b-0">Total Earning: </h6>
                        </div>
                        <div className="col-2 text-right">
                          <i className="icofont icofont-cart-alt f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state?.total_store_order_delivery_charge}</h4>
                          <h6 className="text-muted m-b-0">Total Delivery Charge </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-6">
                  <div className="card">
                    <div className="card-block">
                      <div className="row align-items-center">
                        <div className="col-8">
                          <h4 className="text-c-blue f-w-600">{this.state?.today_store_order_earnings}</h4>
                          <h6 className="text-muted m-b-0">Today Earning </h6>
                        </div>
                        <div className="col-4 text-right">
                          <i className="feather icon-activity f-28"></i>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-c-orenge"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="styleSelector"></div>
        </div>
      </div>
    )
  }
}

export default ShopDashboard
